import styled from '@emotion/styled';

export const Heading = styled('h2', { label: 'Heading' })`
    text-transform: capitalize;
    margin: 5px 0 0 15px;
`;

export const NetDepositLimitWrapper = styled('div', { label: 'NetDepositLimitWrapper' })`
    margin-bottom: 0;
    min-height: 525px;
    overflow: auto;
`;

export const NewLimitInfo = styled('div', { label: 'NewLimitInfo' })`
    margin: 15px 0 0 0;
`;

export const TableWrapper = styled('table', { label: 'TableWrapper' })`
    min-width: 890px;
`;

export const SwitcherWrapper = styled('div', { label: 'SwitcherWrapper' })`
    margin: 15px 0;
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    margin: 5px;
`;

export const EditRowWrapper = styled('div', { label: 'EditRowWrapper' })`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
    min-height: 60px;
    margin: 20px 10px;
`;

export const EmptyContainer = styled('div', { label: 'EmptyContainer' })`
    height: 90px;
    padding: 40px 12px;
`;

export const ButtonsWrapper = styled('th', { label: 'ButtonsWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;


export const PendingRowWrapper = styled('tr', { label: 'PendingRowWrapper' })`
    border-bottom: 2px solid;

    td {
        padding-bottom: 18px;
        padding-top: 0;
    }
`;

export const NetDepositLimitEditRow = styled('tr', { label: 'NetDepositLimitEditRow' })`
    td {
        overflow: visible;
        vertical-align: top;
    }
`;

export const CustomDropdownWrapper = styled('td', { label: 'CustomDropdownWrapper' })`
    min-width: 100px;
    overflow: visible;
    vertical-align: top;

    .net-deposit-inline-menu {
        position: static;
        max-height: none;
        width: 100%;
    }
`;
